<div class="confirm" *ngIf="!showMissionsSection && !showBehaviorsSection && !showEditorUnsavedSection">
  <div class="content-wrapper">
    <img *ngIf="showIcon" class="icon" [src]="iconSrc" [alt]="iconAlt" />
    <div class="messages">
      <p class="message" [style.width]="messageWidth">{{ description }}</p>
      <p *ngIf="secondaryDescription" class="message" [style.width]="messageWidth">
        {{ secondaryDescription }}
      </p>
      <p *ngIf="thirdDescription" class="message" [style.width]="messageWidth">
        {{ thirdDescription }}
      </p>
    </div>
  </div>
  <div class="actions">
    <app-button *ngIf="showPrimaryButton" className="{{ discardBtnClass }}" [titulo]="discardLabel"
      (click)="onConfirm?.()">
    </app-button>
    <app-button *ngIf="showSecondaryButton" className="{{ confirmBtnClass }}" [titulo]="confirmLabel"
      (click)="onKeep?.()">
    </app-button>
  </div>
</div>

<ng-container *ngIf="showMissionsSection">
  <div class="confirm-missions">
    <section class="content-wrapper__missions">
      <img *ngIf="showIcon" class="icon" [src]="iconSrc" [alt]="iconAlt" />

      <!--wrapper para apilar los dos mensajes -->
      <div class="missions-text">
        <p class="message">
          {{ missionMessage }}
        </p>
        <p class="message">
          {{ missionMessageAlt }}
        </p>
      </div>
    </section>

    <section class="content-inform__missions">
      <h3>{{ missionConsiderationsTitle }}</h3>
      <ol>
        <li *ngFor="let item of missionConsiderations">
          {{ item }}
        </li>
      </ol>
    </section>
  </div>
</ng-container>

@if (showBehaviorsSection) {
<div class="confirm-behaviors">
  <h2 class="confirm-behaviors__title">{{ description }}</h2>

  <div class="confirm-behaviors__list">
    @if (selectedBehaviors.length > 0) {
    <div class="confirm-behaviors__selected">
      @for (b of selectedBehaviors; track $index) {
      <app-action-item [title]="b.title" [description]="b.description" [enableEdit]="false" [enableDelete]="true"
        [showDivider]="true" (delete)="removeBehavior($index)">
      </app-action-item>
      }
    </div>
    } @if (availableBehaviors.length > 0) {
    <div class="confirm-behaviors__available">
      @for (b of availableBehaviors; track $index) {
      <app-action-item [title]="b.title" [description]="b.description" [enableEdit]="false" [enableAdd]="true"
        [showDivider]="true" (add)="addBehavior($index)">
      </app-action-item>
      }
    </div>
    }
  </div>

  <div class="confirm-behaviors__actions">
    <app-button className="{{ discardBtnClass }}" [titulo]="discardLabel || 'Cancelar'" (click)="onConfirm?.()">
    </app-button>

    <app-button className="{{ confirmBtnClass }}" [titulo]="confirmLabel || 'Agregar'" [disable]="isSubmitDisabled"
      (click)="submitSelection()">
    </app-button>
  </div>
</div>
}

@if (showEditorUnsavedSection) {
<div class="confirm">
  <div class="content-wrapper">
    @if (showIcon) {
    <img class="icon" [src]="iconSrc" [alt]="iconAlt" />
    }
    <div class="messages">
      <p class="message" [style.width]="messageWidth">{{ description }}</p>
      @if (secondaryDescription) {
      <p class="message" [style.width]="messageWidth">
        {{ secondaryDescription }}
      </p>
      }
    </div>
  </div>
  <div class="actions">
    <app-button className="btn-discard" [titulo]="confirmLabel" (click)="onConfirm?.()">
    </app-button>
    <app-button className="btn-confirm" [titulo]="discardLabel" (click)="onKeep?.()">
    </app-button>
  </div>
</div>
}